// extracted by mini-css-extract-plugin
export default {"root":"CancellationBanner_root__VXYnE","icon":"CancellationBanner_icon__z8LDi","textTop":"CancellationBanner_textTop__OMoxP","textBottom":"CancellationBanner_textBottom__SPq5F"};